import type { TFunction } from "i18next";

type FreqUnit = "daily" | "weekly" | "monthly" | "yearly";

const FREQ_TO_UNIT: Record<string, FreqUnit> = {
	DAILY: "daily",
	WEEKLY: "weekly",
	MONTHLY: "monthly",
	YEARLY: "yearly",
};

function parseRRuleParts(rrule: string): Record<string, string> {
	// App-format RRULE strings (per `serializeRRule.ts`) carry a leading `RRULE:`
	// prefix — `RRULE:FREQ=DAILY;COUNT=10`. Without stripping it, the first
	// `key=value` segment keys as `RRULE:FREQ` and `parts.FREQ` is undefined,
	// so this function silently returns the fallback for every recurring event.
	const normalized = rrule.replace(/^RRULE:/i, "");
	const parts: Record<string, string> = {};
	for (const segment of normalized.split(";")) {
		const [k, v] = segment.split("=");
		if (k && v) parts[k.trim().toUpperCase()] = v.trim().toUpperCase();
	}
	return parts;
}

export function formatRecurrence(rrule: string, t: TFunction): string {
	const parts = parseRRuleParts(rrule);
	const unit = FREQ_TO_UNIT[parts.FREQ];
	if (!unit) return t("event.recurrence.fallback");

	const count = parts.COUNT ? Number.parseInt(parts.COUNT, 10) : null;
	if (count && Number.isFinite(count) && count > 0) {
		return t(`event.recurrence.${unit}Count`, { count });
	}
	return t(`event.recurrence.${unit}`);
}
